import { Component } from '@angular/core';

@Component( {
  selector: 'app-landing-layout',
  templateUrl: './tools-layout.component.html',
  styleUrls: [ './tools-layout.component.scss' ]
} )
export class ToolsLayoutComponent {

  loading = false;

  constructor() {
    // Intentionally blank
  }
}
